var $33aa6a5be8ab144d$exports = {};
$33aa6a5be8ab144d$exports = {
    "(optional)": `(pasirenkama)`,
    "(required)": `(privaloma)`
};


export {$33aa6a5be8ab144d$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
